import { getActions, getReducers, getTypes } from '../initializers';

// public streamer record, used to title a channel page with a name not an id
const identifier = 'POINTS_STREAMER';

export const getStreamerState = (state) => state.points?.streamer;

export const types = getTypes(identifier);
export const actions = getActions(
  identifier,
  (params) => `gameAuth/${encodeURIComponent(params.streamerId)}`
);
const reducer = getReducers(identifier);

export default reducer;
